module.exports = __webpack_public_path__ + "static/logo-name-2-medium-inverted-edcd4d189190a32e55590cdcefa559cd.png";